import { render, staticRenderFns } from "./distpicker.vue?vue&type=template&id=28fcee36&scoped=true&"
import script from "./distpicker.vue?vue&type=script&lang=js&"
export * from "./distpicker.vue?vue&type=script&lang=js&"
import style0 from "./distpicker.vue?vue&type=style&index=0&id=28fcee36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fcee36",
  null
  
)

export default component.exports